import React, {useEffect, useState} from "react";
import {Button, Checkbox} from "antd";
import './cc-accounts.scss';
import {CheckboxChangeEvent} from "antd/es/checkbox";
import {ReactComponent as Delete} from '../../../../../assets/svg/delete.svg';
import {v4 as uuidv4} from "uuid";
import {useStores} from "../../../../store";

export const ControlCenterAccountsComponent = ({onDetailsChange, oemName}) => {
    const {customerStore} = useStores();
    const [accounts, setAccounts] = useState([{active: true, id: '', name: '', uuid: ''}]);

    useEffect(() => {
        customerStore.getOemAccountsList().then();
    }, []);

    useEffect(() => {
        if (customerStore.oemAccountsList.length > 0) {
            const filteredAccounts = customerStore.oemAccountsList
                .filter(account => account.oemName === oemName)
                .map(({ isActive, accountId, accountName, uuid }) => ({
                    active: isActive,
                    id: accountId,
                    name: accountName,
                    uuid
                }));
            setAccounts(filteredAccounts);
        }
    }, [customerStore.oemAccountsList, oemName]);

    useEffect(() => {
        onDetailsChange(accounts.map(({ uuid, ...rest }) => rest));
    }, [accounts]);

    function onAddAccountClick() {
        setAccounts(prevState => [...prevState, {active: true, id: '', name: '', uuid: uuidv4()}]);
    }

    const onCheckboxChange = (id: string, e: CheckboxChangeEvent) => {
        const {checked} = e.target;
        setAccounts(accounts.map(account => account.id === id ? {...account, active: checked} : account));
    }

    const onInputChange = (index: number, field: string, value: string) => {
        setAccounts(accounts.map((account, i) => i === index ? {...account, [field]: value} : account));
    }

    function onDeleteClick(index: number) {
        setAccounts(accounts.filter((_, i) => i !== index));
    }

    return (
        <div className='accounts-container'>
            <div className='accounts-header'>
                <span>Active?</span>
                <div className='account-info'>
                    <span>Account ID</span>
                    <span>Account Name</span>
                </div>
            </div>
            {accounts.map((account, index) => (
                <div className='account-row' key={account.uuid}>
                    <Checkbox
                        className="checkbox"
                        checked={account.active}
                        onChange={(e) => onCheckboxChange(account.id, e)}
                    />
                    <div className='text-inputs'>
                        <input type="number" value={account.id} name='id'
                               onChange={(e) => onInputChange(index, 'id', e.target.value)}/>
                        <input type="text" value={account.name} name='name'
                               onChange={(e) => onInputChange(index, 'name', e.target.value)}/>
                    </div>
                    <div className={`delete ${accounts.length > 1 ? '' : 'hidden'}`}>
                        {accounts.length > 1 && <Delete onClick={() => onDeleteClick(index)}/>}
                    </div>
                </div>
            ))}
            <div className='add-account-btn'>
                <Button type="primary" onClick={onAddAccountClick}>Add account</Button>
            </div>
        </div>
    );
};